export default abstract class ValueObject<T, TJSON, TParams> {
  protected constructor (_: TParams) {};

  abstract toJSON(): TJSON;
  abstract isEqualTo(other: T | null | undefined): boolean;
  abstract toString(): string;
}